import 'slick-carousel';
import 'lity';

// .js-home-mv-slider
$(function() {
	$('.js-home-mv-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplaySpeed: 4000,
		autoplay: true,
		fade: false,
		speed: 500,
		dots: false,
		arrows: true,
	});
});

$('.js-home-news-slider').slick({
  slidesToShow: 1,
  centerMode: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 15000,
  swipe: false,
  cssEase: 'linear',
  // 操作後に止まってしまう仕様の対策
  pauseOnFocus: false,
  pauseOnHover: true,
  pauseOnDotsHover: false,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        centerMode: false,
      }
    }
  ]
});

$(function () {
  if (window.matchMedia('(max-width:787px)').matches) {
    $('.topList').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplaySpeed: 2000,
      autoplay: true,
      speed: 3000,
      dots: true,
      arrows: false,
    });
  }
});
